export default {
  env: process.env.REACT_APP_ENV,
  basePort: process.env.REACT_APP_BASE_PORT,
  demeterPort: process.env.REACT_APP_DEMETER_PORT,
  archePort: process.env.REACT_APP_ARCHE_PORT,
  apiUrl: process.env.REACT_APP_API_URL,
  s3Url: process.env.REACT_APP_S3_URL,
  baseS3BucketName: process.env.REACT_APP_S3_BASE,
  rolloutKey: process.env.REACT_APP_ROLLOUT_KEY,
  amplitudeKey: process.env.REACT_APP_AMPLITUDE_KEY,
  cropwiseApiUrl: process.env.REACT_APP_CROPWISE_API_URL,
  cupApiUrl: process.env.REACT_APP_CUP_API_URL,
  protectorApiUrl: process.env.REACT_APP_PROTECTOR_API_URL,
  protectorCropwiseApiUrl: process.env.REACT_APP_PROTECTOR_CROPWISE_API_URL,
  oauthCropwiseUrl: process.env.REACT_APP_OAUTH_CROPWISE_URL,
  oauthClientID: process.env.REACT_APP_OAUTH_CLIENT_ID,
  oauthClientSecret: process.env.REACT_APP_OAUTH_CLIENT_SECRET,
  adminAppID: process.env.REACT_APP_ADMIN_APP_ID,
  coreServicesApiUrl: process.env.REACT_APP_BASE_API_URL,
  promptEditAllowedEmails: process.env.REACT_APP_PROMPT_EDIT_ALLOWED_EMAILS,
  cropwiseElementsMfeUrl: process.env.REACT_APP_CROPWISE_ELEMENTS_MFE_URL,
  cwElementsEnv: process.env.REACT_APP_ENV_CW_COMPONENTS
};

const siteConfig = {
  siteName: 'Protector Admin',
  footerText: 'Strider ©2019'
};

const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault'
};

const language = 'english';

const jwtConfig = {
  fetchUrl: '/api/',
  secretKey: 'secretKey'
};

export { siteConfig, language, themeConfig, jwtConfig };
